var offcanvasMenu = {
    slideMenu: document.getElementById("slideMenu"),
    slideMenuBody: document.getElementById("slideMenuBody"),
    offcanvasNestedMenus: document.querySelectorAll(".offcanvas-nested"),
    nextLevelNavLinks: document.querySelectorAll(".next-level-nav__link"),
    btnNestedMenuClose: document.getElementById("btnNestedMenuClose"),
    offcanvasLevelIndex: 0,
    init: function () {
        if(this.slideMenu && this.slideMenuBody && this.offcanvasNestedMenus && this.nextLevelNavLinks && this.btnNestedMenuClose && this.btnNestedMenuClose)
        {
            slideMenu.addEventListener("hidden.bs.offcanvas", this.closeOffcanvasMenu);
            btnNestedMenuClose.addEventListener("click", this.closeActiveNestedMenus);
            offcanvasMenu.nextLevelNavLinks.forEach(link => link.addEventListener("click", this.showNestedNav));
        }
    },

    closeOffcanvasMenu: function() {
        slideMenuBody.classList.remove("overflow-hidden");
        offcanvasMenu.offcanvasNestedMenus.forEach(e => e.classList.remove("shown"));
        offcanvasMenu.btnNestedMenuClose.classList.add("collapse");
        offcanvasMenu.btnNestedMenuClose.classList.remove("overflow-hidden");
    },

    showNestedNav: function() {
        slideMenuBody.classList.add("overflow-hidden");
        let nestedOffcanvas = document.getElementById(this.dataset.toggle);
        offcanvasMenu.btnNestedMenuClose.classList.remove("collapse", "overflow-hidden");
        offcanvasMenu.offcanvasNestedMenus.forEach(e => {
            e.classList.remove("active");
            e.classList.add("overflow-hidden");
        });
        nestedOffcanvas.classList.add("shown", "active");
        nestedOffcanvas.classList.remove("overflow-hidden");
        nestedOffcanvas.setAttribute("data-index", ++offcanvasMenu.offcanvasLevelIndex);
    },

    closeActiveNestedMenus: function(){
        slideMenuBody.classList.remove("overflow-hidden");
        let activeNestedMenu = document.querySelector(".offcanvas-nested.shown.active");
        activeNestedMenu.classList.remove("shown");
        setTimeout(function() {
            activeNestedMenu.classList.remove("active");
        }, 600);
        if(activeNestedMenu.dataset.index > 1) {
            document.querySelector(".offcanvas-nested.shown[data-index='" + --offcanvasMenu.offcanvasLevelIndex + "']").classList.add("active");
            document.querySelector(".offcanvas-nested.shown[data-index='" + --offcanvasMenu.offcanvasLevelIndex + "']").remove("overflow-hidden");
        } else {
            offcanvasMenu.btnNestedMenuClose.classList.add("collapse");
            offcanvasMenu.btnNestedMenuClose.classList.remove("overflow-hidden");
            offcanvasMenu.offcanvasLevelIndex--;
        }
    }
}

export default offcanvasMenu;